import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import {
  CrudMasterDetailView,
  GridView,
  Widget,
  FormInput,
  FormSubmitButton,
  FormSelect,
  CompositeView,
  MasterDetailForm,
  FormatText,
  FormTextArea,
  ButtonDelete,
  CrudContext,
  useRouter,
} from '@digital/ui';
import { getAllAreas, Area, createArea, updateArea, deleteArea } from '@app/api/area';
import { Usuario, getAllUsuariosPorPerfil } from '@app/api/usuario';
import { Diretoria, getAllDiretorias } from '@app/api/diretoria';
import { hasPermission } from '../../helpers/permissions';

const validationSchema = Yup.object().shape({
  nome: Yup.string()
    .required('Nome deve ser informado')
    .max(150, 'O nome deve ter no máximo 150 caracteres.'),
  sigla: Yup.string()
    .required('Sigla deve ser informada')
    .max(5, 'A sigla deve ter no máximo 5 caracteres.'),
  descricao: Yup.string().nullable().max(2000, 'A descrição deve ter no máximo 2000 caracteres.'),
  diretoriaId: Yup.string().required('Diretoria deve ser informada'),
  usuarioId: Yup.string().required('Um Usuário Responsável deve ser informado'),
});

const AreaComponent = () => {
  const { history } = useRouter();
  const [usuarios, setUsuarios] = useState<Usuario[]>();
  const [diretorias, setDiretorias] = useState<Diretoria[]>();
  const [areas, setAreas] = useState(() => getAllAreas);

  useEffect(() => {
    const getUsuariosData = async () => {
      const result = await getAllUsuariosPorPerfil(6);
      if (result) setUsuarios(result);
    };

    const getDiretoriasData = async () => {
      const result = await getAllDiretorias();
      if (result) setDiretorias(result);
    };

    getUsuariosData();
    getDiretoriasData();
  }, []);

  const listarAreas = () => {
    setAreas(() => Promise.resolve(undefined));
    setAreas(() => getAllAreas);
  };

  const onCreateArea = (area: Area) => {
    return createArea(area).then((resp: any) => {
      if (resp && resp.valid) listarAreas();
      return resp;
    });
  };

  const onUpdateArea = (area: Area) => {

    return updateArea(area).then((resp: any) => {
      if (resp && resp.valid) listarAreas();
      return resp;
    });
  };

  const onDeleteArea = (id: string) => {
    deleteArea(id).then((resp: any) => {
      if (resp && resp.valid) listarAreas();
      history.push('/areas');
    });
  };

  return (
    <CrudMasterDetailView
      getAllItems={areas}
      createItem={hasPermission(['DIRETORIA_AREA_DEPARTAMENTO_CADASTRAR']) ? onCreateArea : undefined}
      updateItem={hasPermission(['DIRETORIA_AREA_DEPARTAMENTO_EDITAR']) ? onUpdateArea : undefined}
      disableNotification
      icon="business-flow_chart"
      detailTitleExtractor={x => `${x.sigla} - ${x.nome}`}
      filterPredicate={(item, value) =>
        item.nome.toLowerCase().includes(value.toLowerCase()) ||
        (item.nome ? item.nome.toLowerCase().includes(value.toLowerCase()) : false) ||
        (item.sigla ? item.sigla.toLowerCase().startsWith(value.toLowerCase()) : false)
      }
      titleExtractor={item => item.nome}
      descriptionExtractor={item => item.sigla || `--- - ${item.diretoriaNome}`}>
      <CompositeView>
        {true && (
          <CrudContext.Consumer>
            {({ selectedItem }) => {
              return (
                <GridView noform>
                  <MasterDetailForm validationSchema={validationSchema}>
                    <Widget
                      actions={[
                        selectedItem && hasPermission(['DIRETORIA_AREA_DEPARTAMENTO_DELETAR']) && (
                          <ButtonDelete
                            type="link"
                            confirm="Deseja realmente excluir este registro?"
                            okText="Confirmar"
                            onClick={() => onDeleteArea(selectedItem.id)}
                          />
                        ),
                        hasPermission([
                          'DIRETORIA_AREA_DEPARTAMENTO_CADASTRAR',
                          'DIRETORIA_AREA_DEPARTAMENTO_EDITAR',
                        ]) && (
                          <FormSubmitButton type="primary">
                            <FormatText id="ui.commons.save" uppercase />
                          </FormSubmitButton>
                        ),
                      ]}>
                      <FormInput label="Nome" name="nome" span={6} />
                      <FormInput label="Sigla" name="sigla" span={6} />
                      <FormSelect
                        label="Diretoria"
                        name="diretoriaId"
                        placeholder="Selecione uma opção"
                        options={diretorias && diretorias.map(a => ({ text: a.nome, value: a.id.toString() }))}
                        span={6}
                      />
                      <FormSelect
                        showSearch
                        label="Responsavel"
                        name="usuarioId"
                        placeholder="Selecione uma opção"
                        options={usuarios && usuarios.map(a => ({ text: a.nome, value: a.id.toString() }))}
                        span={6}
                      />
                      <FormTextArea label="Descrição" name="descricao" rows={3} />
                    </Widget>
                  </MasterDetailForm>
                </GridView>
              );
            }}
          </CrudContext.Consumer>
        )}
      </CompositeView>
    </CrudMasterDetailView>
  );
};

export default AreaComponent;
